import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Bypass reCAPTCHA for development environments (LAN IPs, localhost).
// This allows real SMS to be sent without requiring a valid domain for reCAPTCHA.
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  const isDevHost =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    /^192\.168\./.test(hostname) ||
    /^10\./.test(hostname) ||
    /^172\.(1[6-9]|2[0-9]|3[01])\./.test(hostname);

  if (isDevHost) {
    // This flag tells Firebase to allow phone auth without reCAPTCHA verification
    console.log('[Firebase] Detected dev environment, disabling reCAPTCHA verification');
    auth.settings.appVerificationDisabledForTesting = true;
  }
}

let messaging;
if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  try {
    const isSupported = (await import('firebase/messaging')).isSupported;
    const supported = await isSupported();
    if (supported) {
      messaging = getMessaging(app);
    } else {
      console.warn('[Firebase] FCM Messaging not supported in this environment');
      messaging = null;
    }
  } catch (e) {
    // Fallback: Messaging not supported in this environment
    console.error('[Firebase] FCM Initialization failed:', e);
    messaging = null;
  }
}

export { app, auth, messaging, getToken, onMessage, RecaptchaVerifier, signInWithPhoneNumber };
